module.exports = __webpack_public_path__ + "static/media/blog6_2.c5c63718.webp";